import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";

import { submitReferralReportEdit } from "../actions";

import { ReferralReport } from "./ReferralReport";

interface OwnProps {
    version: number;
    oldVersionRedirectUrl?: string;
}

export const EditReferralReport: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    const dispatch = useDispatch();

    const submitReport = React.useCallback((ohCaseId: string, taskId: string) => dispatch(submitReferralReportEdit(ohCaseId, taskId)), [dispatch]);

    return (
        <ReferralReport
            version={props.version}
            oldVersionRedirectUrl={props.oldVersionRedirectUrl}
            nextTaskRequired={false}
            submitReport={submitReport}
        />
    );
};
